const o = () => typeof window < "u" && !!window.__MAINFRAME__, n = () => !!document.getElementById("storybook-root");
export {
  o as isInOneNav,
  n as isInStorybook
};
//# sourceMappingURL=is-in-onenav.js.map
